"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class RecordCondition {
    constructor(propertyConditions) {
        this.isOptional = false;
        this.isNullable = false;
        this.propertyConditions = propertyConditions;
    }
    setOptions(options) {
        this.options = options;
        this.propertyConditions.forEach((condition) => {
            condition.setOptions(options);
        });
    }
    optional() {
        this.isOptional = true;
        return this;
    }
    nullable() {
        this.isNullable = true;
        return this;
    }
    isFulfilled(value) {
        if (value === undefined) {
            return this.isOptional ? { fulfilled: true } : { fulfilled: false, reasons: [{ path: "", value: undefined, explanation: "is undefined" }] };
        }
        if (value === null) {
            return this.isNullable ? { fulfilled: true } : { fulfilled: false, reasons: [{ path: "", value: null, explanation: "is null" }] };
        }
        const isObject = typeof (value) === "object" && !(value instanceof Array);
        if (!isObject) {
            return { fulfilled: false, reasons: [{ path: "", value, explanation: "is not an object" }] };
        }
        const result = { fulfilled: true, reasons: [] };
        const checkForSuperfluousProperties = this.options && !this.options.ignoreSuperfluousObjectProperties;
        const definedProperties = [];
        this.propertyConditions.forEach((condition) => {
            const property = condition.getProperty();
            if (checkForSuperfluousProperties && value.hasOwnProperty(property)) {
                definedProperties.push(property);
            }
            const itemResult = condition.isFulfilled(value);
            if (!itemResult.fulfilled) {
                result.fulfilled = false;
                if (itemResult.reasons) {
                    result.reasons = result.reasons.concat(itemResult.reasons);
                }
            }
        });
        if (checkForSuperfluousProperties) {
            const superfluousKeys = Object.keys(value).filter((key) => !definedProperties.includes(key));
            if (superfluousKeys.length > 0) {
                result.fulfilled = false;
                result.reasons = superfluousKeys.map((key) => {
                    return {
                        path: key,
                        value: value[key],
                        explanation: "is not defined here",
                    };
                });
            }
        }
        return result.fulfilled ? { fulfilled: true } : result;
    }
}
exports.RecordCondition = RecordCondition;
//# sourceMappingURL=RecordCondition.js.map